import School from "../../../models/School";
import ApiService from "../../ApiService";
import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import { PrimaryButton, MessageBarType, CommandBarButton } from "office-ui-fabric-react";
import {friendlySchoolName} from "../../../utils/Utils";
import GroundFloorDurableFunctionInstanceList from "../../GroundFloorDurableFunctionInstanceList";
import {GroundFloorDurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import {buildIndexedSchools} from "../../../utils/IndexedSchools";
import LoadingPage from "../../LoadingPage";

interface OnboardRunPlaylistPageProps {
    tenantId: string;
    schoolCode: string;
    timelineItemKey: string;
    playlistName: string;
    helpText: string;
    

    apiService: ApiService;
    history: History;
}

interface OnboardRunPlaylistPageState {
    durableFunctionInstance?: GroundFloorDurableFunctionInstance;
    loading: boolean;
    school?: School;
}

class OnboardRunPlaylistPage extends Component<OnboardRunPlaylistPageProps & DispatchProps, OnboardRunPlaylistPageState> {

    constructor(props: OnboardRunPlaylistPageProps & DispatchProps) {
        super(props);
        this.state = {
            durableFunctionInstance: undefined,
            loading: false
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId) {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardRunPlaylistPageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }
    }

    private async load(): Promise<void> {
        var school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)

        this.setState({
            school
        });
    }

    private triggerPlaylist = async () => {
        if(!this.state.school)
        {
            return;
        }

        
        this.setState({
            loading: true
        });
        
        try
        {
            const durableFunctionInstance = await this.props.apiService.triggerPlaylist(this.state.school, this.props.playlistName);

            await this.props.dispatch(Actions.showMessageBar(`Started ${this.props.playlistName} for ${friendlySchoolName(this.state.school)}`, MessageBarType.success));
            this.setState({
                durableFunctionInstance
            });
        }
        catch(e)
        {
            console.log(e);
            await this.props.dispatch(Actions.showMessageBar(`Failed to start ${this.props.playlistName} for ${friendlySchoolName(this.state.school)}`, MessageBarType.error));
        }
        
        this.setState({
            loading: false
        });
    }
    
    private buildWorkloadInstanceTable() 
    {
        if(!this.state.durableFunctionInstance)
        {
            return;
        }

        const refreshButton = (
            <CommandBarButton
                iconProps={{iconName: "Refresh"}}
                text="Refresh"
                onClick={async () => {
                    const durableFunctionInstance = await this.props.apiService.getGroundFloorDurableFunctionInstance(this.state.durableFunctionInstance!.durableFunctionInstanceId);
                    this.setState({
                        durableFunctionInstance
                    });
                }}
            />
        );
        
        const schools = this.state.school ? [this.state.school] : [];
        return (
            <div className="onboard-timeline-content-center">
                <GroundFloorDurableFunctionInstanceList title={""} enableRowLinks={true} openRowLinksInNewTab={true} instances={[this.state.durableFunctionInstance]} indexedSchools={buildIndexedSchools(schools)} headerExtra={refreshButton}/>
            </div>
        );
    }

    public render(): JSX.Element {
        if (this.state.school === undefined) {
            return <LoadingPage />;
        }

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={this.props.timelineItemKey}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">

                                    {this.buildWorkloadInstanceTable()}

                                    <div className="onboard-timeline-content-center">
                                        {this.props.helpText}
                                    </div>
                                    <div className="onboard-timeline-content-center">
                                        <PrimaryButton
                                            disabled={!this.state.school || this.state.durableFunctionInstance !== undefined || this.state.loading}
                                            onClick={this.triggerPlaylist}
                                            text={this.state.durableFunctionInstance ? `${this.props.playlistName} Started` : `Start ${this.props.playlistName} Playlist`}/>
                                    </div>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={this.props.timelineItemKey} timelineItems={timelineItems}
                                                   completeItem={() => Promise.resolve(true)} enableNext={true}
                                                   enableSave={false} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardRunPlaylistPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            timelineItemKey: ownProps.timelineItemKey,
            playlistName: ownProps.playlistName,
            helpText: ownProps.helpText,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardRunPlaylistPage)